import {
	Alert,
	Box,
	Chip,
	CircularProgress,
	LinearProgress,
	Stack,
	Typography,
} from "@mui/material";
import { CodeListImportJobDto } from "Infrastructure/Api/Api";

interface RunningImportBannerProps {
	job: CodeListImportJobDto | null;
	isPending?: boolean;
}

const formatDate = (dateString: string) => {
	const date = new Date(dateString);
	return date.toLocaleString("cs-CZ", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
	});
};

const getElapsedTime = (startedAt: string) => {
	const start = new Date(startedAt);
	const now = new Date();
	const diffMs = now.getTime() - start.getTime();
	const diffSeconds = Math.floor(diffMs / 1000);
	const minutes = Math.floor(diffSeconds / 60);
	const seconds = diffSeconds % 60;

	if (minutes > 0) {
		return `${minutes}m ${seconds}s`;
	}
	return `${seconds}s`;
};

export const RunningImportBanner: React.FunctionComponent<
	RunningImportBannerProps
> = ({ job, isPending = false }) => {
	return (
		<Alert
			severity="warning"
			icon={<CircularProgress size={20} color="warning" />}
			sx={{ mb: 0 }}
		>
			<Stack spacing={1}>
				<Stack
					direction="row"
					spacing={2}
					alignItems="center"
					flexWrap="wrap"
					useFlexGap
				>
					<Typography variant="body2" fontWeight="medium">
						{isPending ? "Spouštění importu..." : "Probíhá import číselníků"}
					</Typography>
					{job && (
						<>
							<Chip
								label={job.targetEnvironment}
								size="small"
								color="warning"
								variant="outlined"
							/>
							<Chip label={job.localization} size="small" variant="outlined" />
						</>
					)}
				</Stack>

				{job && (
					<Stack
						direction="row"
						spacing={2}
						alignItems="center"
						flexWrap="wrap"
						useFlexGap
					>
						<Typography variant="body2" color="text.secondary">
							Spustil: <strong>{job.startedByName || job.startedBy}</strong>
						</Typography>
						<Typography variant="body2" color="text.secondary">
							Zahájeno: {formatDate(job.startedAt)}
						</Typography>
						<Typography variant="body2" color="text.secondary">
							Trvá: {getElapsedTime(job.startedAt)}
						</Typography>
					</Stack>
				)}

				<Box sx={{ mt: 1 }}>
					<LinearProgress color="warning" />
				</Box>

				<Typography variant="caption" color="text.secondary">
					{isPending
						? "Čekejte prosím, import se spouští..."
						: "Nový import nelze spustit, dokud není aktuální dokončen."}
				</Typography>
			</Stack>
		</Alert>
	);
};
